
import moment from 'moment'
import {daysProper, daysLower} from './values'
import maleAvatar from '../images/male-avatar.jpg'
import femaleAvatar from '../images/female-avatar.jpg'
import Vue from 'vue'

export function isLocalDev () {
  return process.env.NODE_ENV === 'development'
}

export function ftHost () {
  return isLocalDev() ? process.env.VUE_APP_FT_API_DEV_HOST : window.location.protocol + '//' + window.location.hostname
}

export function setItems (target, source, defaults) {
  source = source || {}
  var changed = false
  for (let prop in target) {
    const defaultValue = defaults && defaults[prop]
    const sourceValue = source[prop]
    const newValue = sourceValue === undefined && defaults !== undefined ? defaultValue : sourceValue
    const currentValue = target[prop]
    if (currentValue !== null && typeof currentValue === 'object' && !Array.isArray(currentValue) && !Array.isArray(sourceValue)) {
      // console.log('Setting object', prop, currentValue, newValue, defaultValue)
      setItems(currentValue, newValue, defaultValue)
    } else if (Array.isArray(sourceValue)) {
      if (sourceValue)
        if ((!Array.isArray(currentValue) || sourceValue.length + currentValue.length) && JSON.stringify(currentValue) !== JSON.stringify(sourceValue)) {
          // console.log('Setting array', target, prop, currentValue, sourceValue)
          changed = true
          Vue.set(target, prop, deepClone(sourceValue))
        } else {
          // console.log('Skipping array', target, prop, currentValue, sourceValue)
        }
    } else {
      if (currentValue !== newValue) {
        changed = true
        // console.log('Setting value', target, prop, currentValue, newValue)
        Vue.set(target, prop, newValue)
      } else {
        // console.log('Skipping value', target, prop, currentValue, newValue)
      }
    }
  }
  return changed
}

export function clearItems (object, value = null) {
  for (let prop in object) {
    const sourceValue = object[prop]
    if (sourceValue !== null && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
      clearItems(sourceValue)
    } else if (Array.isArray(sourceValue)) {
      Vue.set(object, prop, [])
    } else {
      Vue.set(object, prop, value)
    }
  }
}

export function deepClone (source, forceValue) {
  source = source || {}
  // var target
  const isArray = Array.isArray(source)
  const useForceValue = forceValue !== undefined
  const target = isArray ? [] : {}
  if (isArray) {
    for (let i = 0, l = source.length; i < l; i += 1) {
      const sourceValue = source[i]
      if (sourceValue !== null && typeof sourceValue === 'object') {
        Vue.set(target, i, deepClone(sourceValue, forceValue))
      } else {
        Vue.set(target, i, useForceValue ? forceValue : sourceValue)
      }
    }
  } else {
    for (let prop in source) {
      const sourceValue = source[prop]
      if (sourceValue !== null && typeof sourceValue === 'object') {
        Vue.set(target, prop, deepClone(sourceValue, forceValue))
      } else {
        Vue.set(target, prop, useForceValue ? forceValue : sourceValue)
      }
    }
  }
  return target
}

export function forceInt (val, allowNegative) {
  const num = forceFloat(val, allowNegative)
  return isNaN(num) || num === null ? num : Math.round(num)
}

export function forceCurrency (val, allowNegative) {
  const num = forceFloat(val, allowNegative)
  return isNaN(num) || num === null ? num : (Math.round(num * 100) / 100).toFixed(2)
}

export function displayPercent (val, allowNegative) {
  const num = forceFloat(val, allowNegative)
  return isNaN(num) || num === null ? num : num * 100
}

export function forceFloat (val, allowNegative) {
  var floatVal = parseFloat(val)
  if (isNaN(floatVal) && typeof val === 'string') floatVal = parseFloat(val.replace(allowNegative ? /[^\d\-.]/g : /[^\d.]/g, ''))
  if (isNaN(floatVal)) return null
  return allowNegative ? floatVal : Math.abs(floatVal)
}

export function escapeRegExp (str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
}

export function parseRegExp (str) {
  return str.match(/^\/(.+)\/([igm])*$/)
}

export function displayTime (dateTime) {
  return dateTime ? moment(dateTime.length > 12 ? dateTime : '2018-01-01 ' + dateTime).format('h:mm A') : null
}

export function displayDate (dateTime) {
  return dateTime ? moment(dateTime).format('YYYY-MM-DD') : null
}

export function displayDateTime (dateTime) {
  return dateTime ? moment(dateTime).format('YYYY-MM-DD h:mm A') : null
}

export function verboseDate (dateTime) {
  return dateTime ? moment(dateTime).format('dddd, MMMM Do, YYYY') : null
}

/**
 * Gets variables in global object.
 * Values are lost on page refresh
 */
export function getGlobalValue (path, key) {
  if (!window.ftGlobalValues) {
    window.ftGlobalValues = {}
  }
  return window.ftGlobalValues[path + '_/_' + key]
}

/**
 * Sets variables in global object.
 * Values are lost on page refresh
 */
export function setGlobalValue (path, key, value) {
  if (!window.ftGlobalValues) {
    window.ftGlobalValues = {}
  }
  window.ftGlobalValues[path + '_/_' + key] = value
}

/**
 * Clears variables in global object.
 * Values are lost on page refresh
 */
export function clearGlobalValue (path, key) {
  if (!window.ftGlobalValues) {
    window.ftGlobalValues = {}
  }
  delete window.ftGlobalValues[path + '_/_' + key]
}

/**
 * Gets variables in local object.
 */
export function getLocalOrGlobalValue (path, key) {
  if (localStorage) {
    return localStorage.getItem(path + '_/_' + key)
  } else {
    return getGlobalValue(path, key)
  }
}

/**
 * Sets variables in local object.
 */
export function setLocalOrGlobalValue (path, key, value) {
  if (localStorage) {
    localStorage.setItem(path + '_/_' + key, value)
  } else {
    setGlobalValue(path, key, value)
  }
}

/**
 * Clears variables in local object.
 */
export function clearLocalOrGlobalValue (path, key) {
  if (localStorage) {
    localStorage.removeItem(path + '_/_' + key)
  } else {
    clearGlobalValue(path, key)
  }
}

/**
 * Pads leading zeros to number
 */
export function pad (num, size) {
  var s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

export function getMemberPhoto (photoUrl, gender) {
  if (!photoUrl) {
    return gender === 'F' ? femaleAvatar : maleAvatar
  } else {
    // TODO: Return server URI in current user record and pull server URI from user record in this.$store
    return photoUrl.match(/^http/i) ? photoUrl : ftHost() + photoUrl
  }
}

const mealPeriodDateCache = new WeakMap()

/**
 * Get meal periods for date/location not blocked by blockers or events
 * @param {*} mealPeriods
 * @param {*} blockers
 * @param {*} events
 * @param {*} sDate
 * @param {*} locationId
 */
export function getApplicableMealPeriods (mealPeriods, blockerByDateMap, eventsByDateMap, sDate, locationId) {
  const date = moment(sDate)
  const fdate = moment(sDate).format('YYYY-MM-DD')
  const dayProperName = daysProper[date.day()]
  const dayLowerName = daysLower[date.day()]
  const year = date.year()
  var mpStart
  var mpEnd
  var mpDayStart
  var mpDayEnd
  var bStart
  var bEnd
  var bDayStart
  var bDayEnd
  var mpLocationId
  return mealPeriods.filter(mp => {
    var mpDateMap = mealPeriodDateCache.get(mp)
    if (!mpDateMap) {
      mpDateMap = {}
      mealPeriodDateCache.set(mp, mpDateMap)
    }
    var result = mpDateMap[fdate]
    if (result !== undefined) return result
    mpStart = mp.startMonth === null ? null : moment([year, mp.startMonth, mp.startDay])
    mpEnd = mp.endMonth === null ? null : moment([year, mp.endMonth, mp.endDay])
    mpDayStart = moment(sDate + ' ' + mp.startTime)
    mpDayEnd = moment(sDate + ' ' + mp.endTime)
    mpLocationId = mp.locationId
    result = !mp.disabled && mp['available' + dayProperName] && (locationId === null || locationId === mpLocationId) &&
      (mp.startMonth === null || date.isBetween(mpStart, mpEnd, null, '[]')) &&
      !(blockerByDateMap[fdate] || []).find(b => {
        bStart = moment(b.startDate + ' ' + b.startTime)
        bEnd = moment(b.endDate + ' ' + b.endTime)
        bDayStart = moment(sDate + ' ' + b.startTime)
        bDayEnd = moment(sDate + ' ' + b.endTime)
        return !b.disabled && b[dayLowerName] &&
          (mpStart.isBetween(bStart, bEnd, null, '[]') || mpEnd.isBetween(bStart, bEnd, null, '[]')) &&
          (mpDayStart.isBetween(bDayStart, bDayEnd, null, '[]') || mpDayEnd.isBetween(bDayStart, bDayEnd, null, '[]')) &&
          (!b.locations.length || b.locations.find(b => b.locationId === mpLocationId))
      }) &&
      !(eventsByDateMap[fdate] || []).find(e => {
        return !e.cancelled &&
          (mpStart.isBetween(bStart, bEnd, null, '[]') || mpEnd.isBetween(bStart, bEnd, null, '[]')) &&
          e.locations.find(l => l.locationsId === mpLocationId)
      })
    mpDateMap[fdate] = result
    return result
  })
}

export function simpleCompare (a, b) {
  if (a < b) return -1
  if (a > b) return 1
  return 0
}

export function setCount (counter, key, value) {
  if (counter[key] === undefined) {
    counter[key] = value
  } else {
    counter[key] += value
  }
}

export function intDateToMoment (intDate) {
  return moment(intDate + '', 'YYYYMMDD')
}

const UUID = (function () {
  var self = {}
  var lut = []
  for (var i = 0; i < 256; i++) {
    lut[i] = (i < 16 ? '0' : '') + i.toString(16)
  }
  self.generate = function () {
    var d0 = Math.random() * 0xffffffff | 0
    var d1 = Math.random() * 0xffffffff | 0
    var d2 = Math.random() * 0xffffffff | 0
    var d3 = Math.random() * 0xffffffff | 0
    return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
      lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
      lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
      lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff]
  }
  return self
})()

export function buildUuid () {
  return UUID.generate()
}

const clubExtractRegexp = new RegExp('^/*[a-zA-Z0-9_]+_([a-zA-Z0-9-]+)(/|$|#)')

export function clubFromLocation () {
  var matches = window.location.pathname.match(clubExtractRegexp)
  // console.log('Club From URI:', matches)
  if (matches) {
    return matches[1]
  }
  console.warn('No club specified or found in path')
  if (isLocalDev()) {
    console.warn('Falling back to VUE_APP_FT_API_DEV_DEFAULT_CLUB', process.env.VUE_APP_FT_API_DEV_DEFAULT_CLUB)
    return process.env.VUE_APP_FT_API_DEV_DEFAULT_CLUB
  }
  return null
}

const modeExtractRegexp = new RegExp('^/*([a-zA-Z0-9_]+)_[a-zA-Z0-9-]+(/|$|#)')

export function modeFromLocation () {
  var matches = window.location.pathname.match(modeExtractRegexp)
  // console.log('Mode From URI:', matches)
  if (matches) {
    return matches[1]
  }
  console.warn('No mode specified or found in path')
  if (isLocalDev()) {
    console.warn('Falling back to VUE_APP_FT_DEV_DEFAULT_API_MODE', process.env.VUE_APP_FT_DEV_DEFAULT_API_MODE)
    return process.env.VUE_APP_FT_DEV_DEFAULT_API_MODE
  }
  return null
}

export function extendBuildJsonPath (path, extend) {
  if (Number.isInteger(extend)) {
    return path + '[' + extend + ']'
  } else if (typeof extend === 'string') {
    if (extend.startsWith('$')) {
      // this is just a json path.  Use that instead
      return extend
    }
    return path + '.' + extend
  }
  return path
}

const escapeChars = {
  '¢': 'cent',
  '£': 'pound',
  '¥': 'yen',
  '€': 'euro',
  '©': 'copy',
  '®': 'reg',
  '<': 'lt',
  '>': 'gt',
  '"': 'quot',
  '&': 'amp',
  '\'': '#39'
}

const escapeEntitiesRegex = new RegExp('[' + Object.keys(escapeChars).reduce((acc, char) => acc + char, '') + ']', 'g')

export function escapeHTML (str) {
  return str.replace(escapeEntitiesRegex, m => '&' + escapeChars[m] + ';')
}

export function updateMenuDimensionsOfChildren (vueComponent) {
  if (!vueComponent.$children.length) return
  vueComponent.$children.forEach(c => {
    if (typeof c.updateMenuDimensions === 'function')  {
      // console.warn('Updating position:', c)
      c.updateMenuDimensions()
    }
    updateMenuDimensionsOfChildren(c)
  })
}

// Flatten routes so we don't pass traffic through an index page.
// Allows animated transitions to work, reduces overhead, simplifies.
export function generateFlatRoutesFromMenu (menu = [], routes = [], parentPath = '') {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path && item.component) {
      const route = {
        name: item.name,
        path: parentPath + item.path,
        props: item.props,
        redirect: item.redirect,
        meta: item.meta
      }
      if (item.component) {
        route.component = item.component
      }
      if (item.components) {
        route.components = item.components
      }
      routes.push(route)
    }
    if (item.children) {
      generateFlatRoutesFromMenu(item.children, routes, parentPath + item.path + '/')
    }
  }
  return routes
}

export function addNewRoutes (router, menuItems) {
  const routes = generateFlatRoutesFromMenu(menuItems)
  const newRoutes = []
  routes.forEach(r => {
    if (!router.resolve({name: r.name}).resolved.matched.length) {
      // Route doesn't exist yet
      newRoutes.push(r)
    }
  })
  router.addRoutes(newRoutes)
}

export function retry (fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error)
            return
          }
          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject)
        }, interval)
      })
  })
}

/**
 * Returns root Vue instance
 */
export function rootVueInstance () {
  return window.$ftApp
}

var _ftAPI = null

/**
 * Returns an ftAPI instance.  Only use if you're not in a vue instance
 */
export function ftAPI () {
  if (_ftAPI === null && rootVueInstance()) {
    _ftAPI = rootVueInstance().$ftAPI()
  }
  return _ftAPI
}

export function loadRetryOrPrompt (fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft <= 1) {
            // Tried to lazy load 5 times, but failed
            // Could be a network connection issue, or could be the app was updated and the old file doesn't exist.
            //
            // TODO: Try to load version of App from remote server to see if we're out-of-date, and if so, tell them as much.
            //       We'll need to store the version in a static json file or something.
            rootVueInstance().$vPrompt({
              title: 'Network Error',
              titleIcon: 'mdi-network-off-outline',
              titleIconColor: 'error',
              text: 'Sorry, having trouble loading a required ForeTees module.<br><br>Please check your network connection and try again.',
              isHtml: true,
              confirmText: 'Retry',
              confirmAction: (dialog) => {
                loadRetryOrPrompt(fn, 1, interval).then(resolve, reject) // Try to import the script again
                dialog.showDialog = false
              },
              cancelText: 'Restart',
              cancelAction: (dialog) => {
                window.location.reload() // Reload the entire page
                dialog.showDialog = false
              }
            })
            reject(error)
          } else {
            // Passing on "reject" is the important part
            loadRetryOrPrompt(fn, retriesLeft - 1, interval).then(resolve, reject)
          }
        }, interval)
      })
  })
}

export function lazyCoreLoading (name) {
  return () => loadRetryOrPrompt(() => import(`../components/${name}.vue`), 2, 1000)
}
